import React, {ReactNode} from 'react';
import {useGetUserAccessWidthState} from "@containers/account/access/hooks/useGetUserAccess";
import ErrorBlock from "@ui/errors/errorBlock/ErrorBlock";
import {useTranslation} from 'react-i18next';

interface IProps {
    keys: string | string[],
    children: ReactNode,
    accessType?: 'strict' | 'or',
}

const UserAccessRoot = ({
                            keys,
                            children,
                            accessType = 'strict'
                        }: IProps) => {

    const {t} = useTranslation()

    const {access} = useGetUserAccessWidthState({
        keys,
        accessType,
    })

    if (!access) {
        return (
            <ErrorBlock>
                {t('base.errorAccess')}
            </ErrorBlock>
        )
    }
    return (
        <>
            {children}
        </>
    );
};

export default UserAccessRoot;